import { Box } from '@material-ui/core';
import { Currency, formatMoney, MetricAggregateView, ProductExternal } from '@nemuru-eng/js-api-client';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { useTimeIntervalLabel } from '@/components/modules/Metrics/shared/hooks/useTimeIntervalLabel';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';

import { HorizontalScoreCard } from '../../shared/components/HorizontalScoreCard';
import { MetricVariation } from '../../shared/components/MetricVariation';
import { TimeInterval } from '../../shared/entities/TimeInterval';
import { ProductExternalMap } from '../../shared/maps/ProductExternal.map';
import { MetricAnalyzer } from '../entities/MetricAnalyzer';

interface ProductExternalScoreCardProps {
  currency: Currency;
  timeInterval: TimeInterval;
  productExternal: ProductExternal;
  filteredMetrics?: MetricAggregateView[];
}

export const ProductExternalScoreCard = ({
  currency,
  timeInterval,
  productExternal,
  filteredMetrics,
}: ProductExternalScoreCardProps) => {
  const timeIntervalLabel = useTimeIntervalLabel(timeInterval);
  const metricsAnalyzer = useMemo(() => new MetricAnalyzer(timeInterval, filteredMetrics), [filteredMetrics]);

  const { totalPrincipalAmount } = metricsAnalyzer.scoreCardMetrics(productExternal);

  return (
    <HorizontalScoreCard
      hideDivider
      icon={
        <Box
          width={40}
          height={40}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          color={'secondary.main'}
        >
          <Icon>{ProductExternalMap.toIcon(productExternal)}</Icon>
        </Box>
      }
      title={
        <Link to={ProductExternalMap.toPath(productExternal)}>
          <Text tId={`PRODUCT_EXTERNAL_${productExternal}`} />
        </Link>
      }
      subtitle={timeIntervalLabel}
      value={formatMoney({ value: totalPrincipalAmount.current, currency }, 0)}
      subValue={
        <MetricVariation
          variation={totalPrincipalAmount.variation}
          // previous={formatMoney({ value: totalPrincipalAmount.previous, currency }, 0)}
        />
      }
    />
  );
};
